import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import store from '../store'
Vue.use(Router)

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const vueRouter = new Router({
	routes: [{
			path: '/',
			name: '首页',
			component: HelloWorld
		},
		// {
		// 	path: '/login',
		// 	name: 'login',
		// 	component(resolve) {
		// 		require(['@/logo/login.vue'], resolve)
		// 	},
		// },
		{
			path: '/home',
			name: 'home',
			component(resolve) {
				require(['@/components/home/home.vue'], resolve)
			},
			children: [{
					path: '/homepage',
					name: '首页',
					component(resolve) {
						require(['@/pages/homepage/homepage.vue'], resolve)
					},
					meta: {
						//判断是否头部各自展示的内容
					  showCotentHeader: 0,
					  //导航栏判断字段
					  indexnumber:0,
					  //是否展示详情导航栏
					  indexDetails:false,
					  dextailsindex:false, //只有时详情页面才有这个字段true
					}
				},
				{
					path: '/hardwareservices',
					name: '硬件服务',
					component(resolve) {
						require(['@/pages/hardwareservices/hardwareservices.vue'], resolve)
					},
					meta: {
						//判断是否展示头部图片
					  showCotentHeader: 1,
					  //导航栏判断字段
					  indexnumber:1,
					  //是否展示详情导航栏
					  indexDetails:false,
					  dextailsindex:false, //只有时详情页面才有这个字段true
					}
				},
				{
					path: '/softwareservices',
					name: '硬件服务',
					component(resolve) {
						require(['@/pages/softwareservices/softwareservices.vue'], resolve)
					},
					meta: {
						//判断是否展示头部图片
					  showCotentHeader: 2,
					  //导航栏判断字段
					  indexnumber:2,
					  //是否展示详情导航栏
					  indexDetails:false,
					  dextailsindex:false, //只有时详情页面才有这个字段true
					}
				},
				{
					path: '/integratedsystem',
					name: '弱电集成系统',
					component(resolve) {
						require(['@/pages/integratedsystem/integratedsystem.vue'], resolve)
					},
					meta: {
						//判断是否展示头部图片
					  showCotentHeader: 3,
					  //导航栏判断字段
					  indexnumber:3,
					  //是否展示详情导航栏
					  indexDetails:false,
					  dextailsindex:false, //只有时详情页面才有这个字段true
					}
				},
				{
					path: '/aboutus',
					name: '关于我们',
					component(resolve) {
						require(['@/pages/aboutus/aboutus.vue'], resolve)
					},
					meta: {
						//判断是否展示头部图片
					  showCotentHeader: 4,
					  //导航栏判断字段
					  indexnumber:4,
					  //是否展示详情导航栏
					  indexDetails:false,
					  dextailsindex:false, //只有时详情页面才有这个字段true
					}
				},
				{
					path: '/softwareservicesDetails',
					name: '软件详情',
					component(resolve) {
						require(['@/pages/softwareservices/softwareservicesDetails.vue'], resolve)
					},
					meta: {
						//判断是否展示头部图片
					  showCotentHeader: 5,
					  //导航栏判断字段
					  indexnumber:5,
					  //是否展示详情导航栏
					  indexDetails:true,
					  dextailsindex:true, //只有时详情页面才有这个字段
					}
				},
				{
					path: '/integratedsystemDetails',
					name: '集成详情',
					component(resolve) {
						require(['@/pages/integratedsystem/integratedsystemDetails.vue'], resolve)
					},
					meta: {
						//判断是否展示头部图片
					  showCotentHeader: 6,
					  //导航栏判断字段
					  indexnumber:6,
					  //是否展示详情导航栏
					  indexDetails:true,
					  dextailsindex:true, //只有时详情页面才有这个字段true
					}
				},
				{
					path: '/hardwareservicesdetals',
					name: '硬件详情',
					component(resolve) {
						require(['@/pages/hardwareservices/hardwareservicesdetals.vue'], resolve)
					},
					meta: {
						//判断是否展示头部图片
					  showCotentHeader: 7,
					  //导航栏判断字段
					  indexnumber:7,
					  //是否展示详情导航栏
					  indexDetails:true,
					  dextailsindex:true, //只有时详情页面才有这个字段true
					}
				},
				{
					path: '/qualitypointer',
					name: '质量指针',
					component(resolve) {
						require(['@/pages/hardwareservices/qualitypointer.vue'], resolve)
					},
					meta: {
						//判断是否展示头部图片
					  showCotentHeader: 7,
					  //导航栏判断字段
					  indexnumber:7,
					  //是否展示详情导航栏
					  indexDetails:true,
					  dextailsindex:true, //只有时详情页面才有这个字段true
					}
				},
			]
		}
	]
})
vueRouter.beforeEach((to, from, next) => {
	// 判断中英文
	let chineseEnglish = localStorage.getItem('chineseEnglish')
	store.commit('chineseEnglish',chineseEnglish)
	
	//这里判断进来的当前中英文状态的公共值,所有判断中英文状态的显示隐藏都可以使用
	//通过vuex引入在页面中使用
	if(chineseEnglish == 2){
		store.commit('orderTreu',true);
	}else{
		store.commit('orderTreu',false);
	}
	
	// console.log(to,from);
	store.commit('pathIndex',to.path)
	store.commit('changeValue',to.meta)
	localStorage.setItem('pathchaoyi',to.path)
	// let login = localStorage.getItem('vueid')
	let login = '88888'
	let path = to.path;
	let arrlist = [{
		"path": to.path,
		"name": to.name
	}];
	if (path === '/login') {
		next()
		return
	}
	if (login) {
		if (path === '/') {
			next({
				path: '/homepage'
			})
			// if (sessionStorage.getItem('tabDatalist') == null) {
			// 	sessionStorage.setItem("tabDatalist", JSON.stringify(arrlist));
			// };

			//参数 用来刷新  页面时 判断是否有这个页面
			// sessionStorage.setItem("tablist", JSON.stringify([{
			// 	"path": '/homecontent',
			// 	"name": to.name
			// }]));

			// sessionStorage.setItem("rotuder", '/homecontent');

			//			store.dispatch("routerlist", { id: '' }).then(res => {
			//				console.log(res);
			//			});
		} else {

			//			store.dispatch("addlist", { id: '' }).then(res => {
			//				console.log(res);
			//			});

			//调用接口传在vuex里面
			//			store.dispatch("routerlist", { id: '' });


			//当sessionStorage里面没有 tabDatalist数组时
			// if(sessionStorage.getItem('tabDatalist') == null){
			// 	sessionStorage.setItem("tabDatalist", JSON.stringify(arrlist));
			// };

			//参数 用来刷新  页面时 判断是否有这个页面
			// sessionStorage.setItem("tablist",JSON.stringify(arrlist));

			// sessionStorage.setItem("rotuder",path);
			next()
		}
	} else {
		next({
			path: '/login'
		})
	}
})

export default vueRouter;



// WEBPACK FOOTER //
// ./src/router/index.js